import { DialogTriggerProps } from '@radix-ui/react-dialog';
import { Dialog } from 'components/ui';

export const AiEditorTrigger = ({ children, ...rest }: DialogTriggerProps) => {
  return <Dialog.Trigger {...rest}>{children}</Dialog.Trigger>;
};
